//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _customerWorkflow from './customerWorkflow';
export const customerWorkflow = _customerWorkflow;
export default {customerWorkflow};

